'use client'

import { navigationVariants } from '@/components/Header/Navigation'
import { I18NText } from '@/components/I18NText'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export const AdminNavigation = () => {
	const pathname = usePathname()

	return (
		<div className="flex justify-center gap-2">
			<Link
				href="/admin"
				className={navigationVariants({
					state: pathname === '/admin' ? 'active' : 'default',
				})}
			>
				<I18NText text="organizations.pageTitle" />
			</Link>
			<Link
				href="/admin/factors"
				className={navigationVariants({
					state: pathname === '/admin/factors' ? 'active' : 'default',
				})}
			>
				<I18NText text="emissionFactors.pageTitle" />
			</Link>
			<Link
				href="/admin/activities"
				className={navigationVariants({
					state: pathname === '/admin/activities' ? 'active' : 'default',
				})}
			>
				<I18NText text="activities.pageTitle" />
			</Link>
			<Link
				href="/admin/account-mapping"
				className={navigationVariants({
					state: pathname === '/admin/account-mapping' ? 'active' : 'default',
				})}
			>
				<I18NText text="accountMapping.pageTitle" />
			</Link>
		</div>
	)
}
